import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveAllergy, IClientDetailsStore, IClientDetailsActions } from '../types';

const onArchiveAllergy: IThunkArchiveAllergy = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.archiveAllergy(payload);

    const allergies = localState.allergies.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: true },
    );

    setClientDetails({ allergies });
  },
);

export default onArchiveAllergy;
